// pdf.js worker for every @react-pdf-viewer Viewer. It must match the pdfjs-dist
// version @react-pdf-viewer/core was built against.
export const PDF_WORKER_URL = 'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
